var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#E5EDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7902V21.5022H12.708L20.695 13.5122L17.987 10.8022L10 18.7902ZM22.789 11.4172C22.8559 11.3504 22.9091 11.2711 22.9453 11.1838C22.9815 11.0964 23.0002 11.0028 23.0002 10.9082C23.0002 10.8137 22.9815 10.72 22.9453 10.6327C22.9091 10.5454 22.8559 10.466 22.789 10.3992L21.1 8.70923C21.0332 8.64229 20.9539 8.58917 20.8665 8.55294C20.7792 8.5167 20.6856 8.49805 20.591 8.49805C20.4964 8.49805 20.4028 8.5167 20.3155 8.55294C20.2281 8.58917 20.1488 8.64229 20.082 8.70923L18.759 10.0312L21.467 12.7392L22.789 11.4172Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.450ce08321613b21ce2d976e0475f569.svg";
export { ForwardRef as ReactComponent };